import type { CMYKColor, RGBColor } from "@pdfking/math"
import { CreateColorConvert, Mean } from "@pdfking/math"

const black_only = (alpha: number, black: number) =>
  ({
    cyan: 0,
    magenta: 0,
    yellow: 0,
    black,
    alpha,
  }) as CMYKColor

// Zeroing C/M/Y turns e.g. the Cyan colorbar tile into a plain black-only
// tint — it no longer means "Cyan ink", so a transformed color must not
// carry over `idml_reserved`/`idml_model`. Colors already K-only pass
// through unchanged (same reference) so their metadata survives.
export const BnProcessor = CreateColorConvert(
  ({ red, green, blue, alpha }: RGBColor) => black_only(alpha, Mean(red, green, blue)),
  (cmyk: CMYKColor) =>
    cmyk.cyan || cmyk.magenta || cmyk.yellow ? black_only(cmyk.alpha, cmyk.black) : cmyk
)
